import { StudentRepository } from '@/repository/StudentRepository'
import { ParentRepository } from '@/repository/ParentRepository'
import { TeacherRepository } from '@/repository/TeacherRepository'
import { Parent } from '@/models/Parent'
import { Teacher } from '@/models/Teacher'

class LessonDeleter {

  constructor(client, user){
    if (!(client)) {
      throw new Error(`'client' is required.`)
    }
    this.deleter = LessonDeleterFactory.create(client, user)
  }

  async execute(lessonId) {
    return await this.deleter.execute(lessonId)
  }
}

class LessonDeleterFactory {

  static create(client, user) {
    if (user instanceof Parent) {
      return new ParentLessonDeleter(client, user)
    } else if (user instanceof Teacher) {
      return new TeacherLessonDeleter(client, user)
    } else {
      throw new Error(`'user' must be an instance of either [object Parent] or [object Teacher]. Actual: ${typeof user}`)
    }
  }
}

class ParentLessonDeleter {
  constructor(client, parent) {
    this.studentRepo = new StudentRepository(client)
    this.parentRepo = new ParentRepository(client)
    this.teacherRepo = new TeacherRepository(client)
    this.parent = parent
  }

  async execute(lessonId) {
    let student = this.parent.getStudents().findByLessonId(lessonId)
    let lesson = student.getLessons().find(lessonId)
    let teacher = await this.teacherRepo.find(lesson.teacherId)
    teacher = await this.teacherRepo.update(teacher.deleteLesson(lessonId))
    student = await this.studentRepo.update(student.deleteLesson(lessonId))
    return await this.parentRepo.update(this.parent.updateStudent(student))
  }
}

class TeacherLessonDeleter {
  constructor(client, teacher) {
    this.studentRepo = new StudentRepository(client)
    this.parentRepo = new ParentRepository(client)
    this.teacherRepo = new TeacherRepository(client)
    this.teacher = teacher
  }

  async execute(lessonId) {
    let lesson = this.teacher.getLesson(lessonId)
    let parent = await this.parentRepo.find(lesson.parentId)
    let student = parent.getStudents().findByLessonId(lessonId)
    student = await this.studentRepo.update(student.deleteLesson(lessonId))
    parent = await this.parentRepo.update(parent.updateStudent(student))
    return await this.teacherRepo.update(this.teacher.deleteLesson(lessonId))
  }
}

export { LessonDeleter }